import { render, staticRenderFns } from "./featureList.vue?vue&type=template&id=3f6024bc&scoped=true&"
import script from "./featureList.vue?vue&type=script&lang=js&"
export * from "./featureList.vue?vue&type=script&lang=js&"
import style0 from "./featureList.vue?vue&type=style&index=0&id=3f6024bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6024bc",
  null
  
)

export default component.exports